// File: src/components/icons/TelescopeIcon.js
import React from 'react';

/**
 * Simple inline-SVG telescope icon used for the "info" buttons across
 * sections. Replaces a hotlinked icons8.com PNG so the UI doesn't depend
 * on a third-party CDN being reachable.
 *
 * className is spread onto the <svg> itself so existing Tailwind sizing
 * classes (e.g. "w-4 h-4 sm:w-6 sm:h-6") keep working unchanged.
 */
const TelescopeIcon = ({ className, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="#ffffff"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    {...props}
  >
    {/* Telescope tube, angled */}
    <path d="M3 14.5 L18 6.5 L20.5 11 L5.5 19 Z" />
    {/* Objective end (wide end of the tube) */}
    <path d="M17 5.5 L20.5 4 L22 7.5 L18.5 9" />
    {/* Eyepiece */}
    <circle cx="4.5" cy="15.5" r="1.6" />
    {/* Stand / tripod legs */}
    <path d="M9 18.5 L6.5 22" />
    <path d="M12 20 L11 22.5" />
    <path d="M9 18.5 L12 20" />
  </svg>
);

export default TelescopeIcon;
